module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Let\u0027s discuss your future mobile app","action":"Contact us"},"ru":{"title":"Обсудим ваше будущее мобильное приложение?","action":"Связаться с нами"}}')
  delete Component.options._Ctor
}
